import { Seccion } from './seccion';
import { TipoBeca } from './tipoBeca';

export class TipoBecaSeccion{

    TipoBecaSeccionID: number;
    Seccion: Seccion;
    TipoBecaNombre : string;
}